// 平台管理员url前缀
export const platformUserPrefix = '/platformUser'

// 租户管理员url前缀
export const tenantUserPrefix = '/tenantUser'

// 诊所代理人url前缀
export const operatorPrefix = '/operator'

// 医生url前缀
export const doctorPrefix = '/doctor'

// 会员url前缀
export const memberPrefix = '/member'

export const business = '/tad-business-backend'

export const platform = '/tad-platform-backend'



// WEBPACK FOOTER //
// ./src/api/common/index.js